import React, { FC } from 'react';
import { useParams } from 'react-router';
import { LoanFormat, parseLoanFormat } from '../../../../models/LoanFormat';
import { EntryPage } from '../EntryPage';

export const LanguageEntryPage: FC = () => {
    const { loanFormat: loanFormatParam, shopLanguage } = useParams<'languageId' | 'loanFormat' | 'shopLanguage'>();
    const loanFormat = parseLoanFormat(loanFormatParam) ?? LoanFormat.eBooks;

    return <EntryPage pageType="LANGUAGES" loanFormat={loanFormat} shopLanguage={shopLanguage} />;
};
